import axios from 'axios'
import AuiToast from '../../assets/js/aui-toast'

/**
 *  获取项目的所有策略
 * @param {*String} projectId 项目id
 * @returns {Promise<void>}
 */
const getAllStrategys = async (projectId) => {
  AuiToast.loading({
    title: 'loading...',
    duration: 2000
  }, function (ret) {})
  return axios.get(`/api/v2/strategy-templates?projectId=${projectId}`, {})
    .then(res => {
      AuiToast.hide()
      return res
    })
}
/**
 *  删除策略
 * @param {*String} strategyId 策略id
 * @returns {Promise<void>}
 */
const deleteStrategy = async (strategyId) => {
  AuiToast.loading({
    title: 'loading...',
    duration: 2000
  }, function (ret) {})
  return axios.delete(`/api/v2/strategy-templates/${strategyId}`, {})
    .then(res => {
      AuiToast.hide()
      return res
    })
}
/**
 *  删除恒流恒压策略
 * @param {*String} strategyId 策略id
 * @returns {Promise<void>}
 */
const deleteDoubleStrategy = async (strategyId, projectId) => {
  AuiToast.loading({
    title: 'loading...',
    duration: 2000
  }, function (ret) {})
  return axios.delete(`/api/v2/strategy-templates/vol-curr-delete/${strategyId}?projectId=${projectId}`, {})
    .then(res => {
      AuiToast.hide()
      return res
    })
}
/**
 * 新增策略
 * @param {*String} options.projectId 所属项目id
 * @param {*String} options.name 策略名称
 * @param {*Array} options.strategyTimes 时间段
 *   @param {*String} options.strategyTimes.time 时间
 *   @param {*Number} options.strategyTimes.brightness 亮度
 * @param {*String} options.offtime 关灯时间
 * @param {*Boolean} options.lightControl 开启光控
 * @param {*Boolean} options.lowerLedControl 开启智能功率
 * @param {*Boolean} options.trafficControl 开启人流控
 * @param {*String} options.remark 备注
 */
const createStrategy = async (option) => {
  AuiToast.loading({
    title: 'loading...',
    duration: 2000
  }, function (ret) {})
  return axios.post(`/api/v2/strategy-templates?projectId=${option.projectId}`, option)
    .then(res => {
      AuiToast.hide()
      return res
    })
}
/**
 * 新增恒流恒压策略
 */
const createDoubleStrategy = async (projectId, option) => {
  AuiToast.loading({
    title: 'loading...',
    duration: 2000
  }, function (ret) {})
  return axios.post(`/api/v2/strategy-templates/vol-curr-save?projectId=${projectId}`, option)
    .then(res => {
      AuiToast.hide()
      return res
    })
}
/**
 * 修改恒流恒压策略
 */
const updataDoubleStrategyInfor = async (projectId, options) => {
  AuiToast.loading({
    title: 'loading...',
    duration: 2000
  }, function (ret) {})
  return axios.put(`/api/v2/strategy-templates/vol-curr-update?projectId=${projectId}`, options)
    .then(res => {
      AuiToast.hide()
      return res
    })
}
/**
 * 获取单个策略
 * @param {*String} strategyId 策略id
 */
const getStrategyInfor = async (strategyId) => {
  AuiToast.loading({
    title: 'loading...',
    duration: 2000
  }, function (ret) {})
  return axios.get(`/api/v2/strategy-templates/${strategyId}`, {})
    .then(res => {
      AuiToast.hide()
      return res
    })
}
/**
 * 修改策略
 * @param {*String} options.strategyID 策略id
 * @param {*String} options.projectId 所属项目id
 * @param {*String} options.name 策略名称
 * @param {*Array} options.strategyTimes 时间段
 *   @param {*String} options.strategyTimes.time 时间
 *   @param {*Number} options.strategyTimes.brightness 亮度
 * @param {*String} options.offtime 关灯时间
 * @param {*Boolean} options.lightControl 开启光控
 * @param {*Boolean} options.lowerLedControl 开启智能功率
 * @param {*Boolean} options.trafficControl 开启人流控
 * @param {*String} options.remark 备注
 */
const updataStrategyInfor = async (options) => {
  AuiToast.loading({
    title: 'loading...',
    duration: 2000
  }, function (ret) {})
  return axios.put(`/api/v2/strategy-templates/${options.strategyID}`, options)
    .then(res => {
      AuiToast.hide()
      return res
    })
}
const strategy = {
  getAllStrategys,
  deleteStrategy,
  createStrategy,
  getStrategyInfor,
  updataStrategyInfor,
  createDoubleStrategy,
  updataDoubleStrategyInfor,
  deleteDoubleStrategy
}
export default strategy
